export const getAvailableChannel = (channels = [], channelId = '') => {
	const channel = channels.find(({ uuid }) => uuid === channelId);

	if (channelId && !channel) {
		return null;
	} else if (channel?.subscriberLocalLimited || !channel) {
		return channels.find(
			({ currentLiveIndex, noPrograms, subscriberLocalLimited }) =>
				currentLiveIndex >= 0 && !noPrograms && !subscriberLocalLimited
		);
	}

	return channel;
};
